import List from './views/List'

export default [{
  path: '/exceptions',
  name: 'exceptions.list',
  component: List
}]
